__webpack_require__.p = "/site-builder-assets/b2c/1192a825b7c67cbc84bd65bce446a9953e607a9a/dist/";